import { render, staticRenderFns } from "./payslip.vue?vue&type=template&id=58774364&"
import script from "./payslip.vue?vue&type=script&lang=js&"
export * from "./payslip.vue?vue&type=script&lang=js&"
import style0 from "./payslip.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports